module.exports = __webpack_public_path__ + "static/img/30006 (3).fb9b54e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30006 (3).webp
// module id = VyTF
// module chunks = 14